import "./styles.less";

import { List, Radio, Skeleton, Table, Typography } from "antd";
import { useContext, useEffect, useState } from "react";

import cookie from "js-cookie";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import { useUnits } from "./hook";
import { useRouter } from "next/router";
import { firstLetterToUppercase, getInitialContactForm } from "src/utils/Functions";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { CommercialUnit } from "shared-components";
import { useUser } from "shared-components/Components/User/User.hook";
import { CountryCode, getCountryCallingCode } from "libphonenumber-js";
import {
	getInitCountryCode
} from "shared-components/Components/Property/InformationRequest/LeadButtons/PhoneButton/web";
import { useContactModal } from "shared-components/Contexts/ContactModal/context";

import { getBaseDomain as loginBasePath, hasRooms, makePriceText } from "@Utils/Functions";

interface UnitsProps {
	comertialUnits: CommercialUnit[];
	loading?: boolean;
	isProjectActive?: boolean;
}

export const Units = ({ comertialUnits, loading = false, isProjectActive = true }: UnitsProps) => {
	const { translations, country_code } = useContext(ConfigStateContext);
	const { query } = useRouter();
	const {
		filters,
		units,
		sendLead,
		registerMutation,
		updateUser,
		userExistsCustomQuery,
		dataRegisterMutation,
	} = useUnits({ comertialUnits, utm: query });
	const { openContactModal, closeContactModal } = useContactModal();
	// const { loginBasePath } = getConfig().publicRuntimeConfig;
	const { user, isLoggedIn } = useUser();
	const [filterBy, setFilterBy] = useState("all");
	const [unitID, setUnitID] = useState(null);
	const [dataModal, setDataModal] = useState({
		name: "",
		phone: "",
		email: "",
		fincatyc: false,
	});
	const [selectedCountryCode, setSelectedCountryCode] = useState({
		code: "",
		value: "",
	});
	const [relatedModal, setRelatedModal] = useState(false);
	const [asked, setAsked] = useState([]);
	const [data, setData] = useState([]);
	const screen = useBreakpoint();

	useEffect(() => {
		if (filterBy === "all") {
			setData(units);
		} else {
			setData(filters[filterBy].units);
		}
	}, [units, filterBy]);

	useEffect(() => {
		if (country_code) {
			setSelectedCountryCode({
				code: country_code as CountryCode,
				value: `+${getCountryCallingCode(country_code as CountryCode)}`,
			})
		}
	}, [country_code]);

	const radioChange = e => {
		setFilterBy(e.target.value);
	};

	const refreshAuth = data => {
		cookie.set("frontend_token", data.access_token, {
			expires: 365,
			domain: loginBasePath(),
			path: "/",
		});
		localStorage.setItem("user_md5", data.user_md5);
		user.refetch();
	};

	useEffect(() => {
		if (dataRegisterMutation) {
			refreshAuth(dataRegisterMutation.registerIndividual);
		}
	}, [dataRegisterMutation]);

	useEffect(() => {
		setDataModal(getInitialContactForm(isLoggedIn, user?.data));
		setSelectedCountryCode(getInitCountryCode());
	}, []);

	const handleAskDisponibility = async (e, unitID) => {
		e.preventDefault();
		e.stopPropagation();

		const dataModal = getInitialContactForm(isLoggedIn, user.data);
		let res = await sendLead(unitID, {
			name: dataModal.name,
			phone: selectedCountryCode.value + dataModal.phone,
			email: dataModal.email,
		});

		if (res) {
			setAsked([...asked, unitID]);
			setRelatedModal(true);
			closeContactModal();
		}
	};

	const askFastDisponibility = async (unitID) => {
		let res = await sendLead(unitID);

		if (res) {
			setAsked([...asked, unitID]);
			setRelatedModal(true);
			closeContactModal();
		}
	};

	if (loading) return <Skeleton active />;

	const bedroomsExactMode = query.bedroomsExactMode === "true";
	const roomsExactMode = query.roomsExactMode === "true";

	return (
		<div className="project-units-section">
			{country_code !== "CO" && (
				<Radio.Group
					className="project-units-filters"
					onChange={radioChange}
					value={filterBy}
					style={{ marginBottom: 15 }}>
					<Radio.Button value="all">
						{"Todos"} ({units.length})
					</Radio.Button>
					{filters.length > 1
						? filters.map((filter, i) => (
							<Radio.Button key={"unit_" + i} value={i}>
								{filter.beds == 0
									? `${firstLetterToUppercase(translations.mono)} (${filter.units.length
									})`
									: `${filter.beds} ${"dorm"} (${filter.units.length})`}{" "}
							</Radio.Button>
						))
						: null}
				</Radio.Group>
			)}

			{screen.lg && (
				<UnitsTable
					data={data}
					asked={asked}
					askFastDisponibility={askFastDisponibility}
					handleAskDisponibility={handleAskDisponibility}
					isProjectActive={isProjectActive}
					bedroomsExactMode={bedroomsExactMode}
					roomsExactMode={roomsExactMode}
				/>
			)}

			{!screen.lg && (
				<UnitsList
					data={data}
					asked={asked}
					askFastDisponibility={askFastDisponibility}
					handleAskDisponibility={handleAskDisponibility}
					isProjectActive={isProjectActive}
					bedroomsExactMode={bedroomsExactMode}
					roomsExactMode={roomsExactMode}
				/>
			)}
		</div>
	);
};

/**
 * Lists of Units Presentational componets
 */

// For responsive
const UnitsList = ({ data, asked, askFastDisponibility, handleAskDisponibility, isProjectActive, bedroomsExactMode, roomsExactMode }: any) => {
	const { isLoggedIn } = useUser();
	const { openContactModal } = useContactModal();
	const { translations, country_code } = useContext(ConfigStateContext);
	const needAbbreviate = country_code === "CO"

	const getAbbreviatedWord = (word, lettersLength, abbreviate) => {
		if (!abbreviate) return word;
		if (!word || typeof word !== "string") return "";
		if (lettersLength <= 0) return "";

		return word.length > lettersLength
			? word.slice(0, lettersLength) + "."
			: word;
	}

	return (
		<>
			<List
				itemLayout="horizontal"
				dataSource={data}
				renderItem={(item: any) => (
					<List.Item className="proyect_units_list_item">
						<div className="units_items">
							<div className="unit_item">
								<Typography.Text strong={true}>m² {getAbbreviatedWord(translations.totales_tipologias, 5, needAbbreviate)}</Typography.Text>
								<span>{item.m2 ?? "--"}</span>
							</div>
							<div className="unit_item">
								<Typography.Text strong={true}>m² {getAbbreviatedWord(translations.construidos_tipologias, 4, needAbbreviate)}</Typography.Text>
								<span>{item.m2Built ?? "--"}</span>
							</div>
							{item.property_type && (
								<div className="unit_item">
									<Typography.Text strong={true}>
										Tipo de Inmueble
									</Typography.Text>
									<span>{item.property_type?.name}</span>
								</div>
							)}
							<div className="unit_item">
								<Typography.Text strong={true}>{`${firstLetterToUppercase(
									translations.hab
								)}${country_code === "CO" ? "/Amb" : ""}`}</Typography.Text>
								<span>
									{
										Number(item.property_type?.id) === 3 && (item.rooms === 0 || item.bedrooms === 0) ?
											"-"
										: item.property_type && hasRooms(item.property_type.id, country_code) ?
											`${item.rooms == null || item.rooms === "" ? 0 : item.rooms} Amb`
											: item.bedrooms >= 0 ?
												item.bedrooms === 0 && country_code !== "CO"
													? firstLetterToUppercase(translations.mono)
													: `${item.bedrooms} ${firstLetterToUppercase(translations.hab)}`
												: "-"
									}
								</span>
							</div>
							<div className="unit_item">
								<Typography.Text strong={true}>{"Baños"} </Typography.Text>
								<span>
									{Number(item.property_type?.id) === 3 && item.bathrooms === 0
										? "-"
										: item.bathrooms}
								</span>
							</div>

							{country_code == "CO" && (
								<div className="unit_item">
									<Typography.Text strong={true}>{"Precio"} </Typography.Text>
									<span className="nowrap">
										{makePriceText({
											...item.price,
											currency: { name: "$", id: "3" },
										})}
									</span>
								</div>
							)}
							{country_code !== "CO" && (
								<div className="unit_item">
									<Typography.Text strong={true}>{"Precio"} </Typography.Text>
									<span className="nowrap">{makePriceText(item.price)}</span>
								</div>
							)}
							{country_code !== "CO" && (
								<div className="unit_item">
									<Typography.Text strong={true}>
										{"Precio" + " / m²"}
									</Typography.Text>
									<span className="nowrap">
										{item.price &&
											item.m2 &&
											makePriceText({
												...item.price,
												amount: item.price.amount / item.m2,
											})}
									</span>
								</div>
							)}
						</div>
						<div className="units_ask_stuff">
							{asked.some(elem => elem == item.id) ? (
								<Typography.Text disabled>{"¡Preguntado!"}</Typography.Text>
							) : (
								<button
									className="btnText"
									disabled={!isProjectActive}
									onClick={() => {
										if (!isLoggedIn) {
											openContactModal({
												id: item.id,
												owner: null,
												isProject: false,
												projectId: null,
												defaultMessage: "",
												source: "propertyDetail",
												isExpress: true,
												expressCallback: (e) => handleAskDisponibility(e, item.id),
												ctaToShow: {
													contact: true,
													phone: false,
													whatsapp: false
												}
											})
										} else {
											askFastDisponibility(item.id);
										}
									}}
								>
									{"Averiguar Disponibilidad"}
								</button>
							)}
						</div>
					</List.Item>
				)}
			/>
		</>
	);
};

// For Desktop
const UnitsTable = ({ data, asked, askFastDisponibility, handleAskDisponibility, isProjectActive, bedroomsExactMode, roomsExactMode }: any) => {
	const { isLoggedIn } = useUser();
	const { openContactModal } = useContactModal();
	const { translations, country_code } = useContext(ConfigStateContext);

	return (
		<>
			<Table dataSource={data} pagination={false} rowKey={rd => "unit_" + rd.id}>
				<Table.Column
					title={
						<span className="small-text">
							{/* m2 -> construidos (CO) / totales (!CO) */}
							m² {translations.totales_tipologias}
						</span>
					}
					dataIndex="m2"
					key="m2"
					render={m2 => <>{
						m2 ? `${m2} m²` : "--"
					}</>}
					width={100}
				/>
				<Table.Column
					title={
						<span className="small-text">
							m² {translations.construidos_tipologias}
						</span>
					}
					dataIndex="m2Terrain"
					key="m2Terrain"
					render={(m2Terrain, record) => (
						<>
							{
								m2Terrain
									? `${m2Terrain} m²`
									: (record.m2Terrace
										? `${record.m2Terrace} m²`
										: "--")
							}
						</>
					)}
					width={100}
				/>
				<Table.Column
					title={<span className="small-text">Tipo de inmueble</span>}
					dataIndex="property_type"
					key="property_type"
					render={property_type => <>{property_type ? property_type?.name : "-"}</>}
				/>
				<Table.Column
					title={
						<span className="small-text">
							{firstLetterToUppercase(translations.hab)}
							{country_code === "CO" ? "/Amb" : ""}
						</span>
					}
					dataIndex="bedrooms"
					key="bedrooms"
					render={(bedrooms, record: any) => {
						const isTerrain = Number(record.property_type?.id) === 3;
						return (
							<>
								{
									isTerrain && (record.rooms === 0 || bedrooms === 0) ?
										"-"
									: record.property_type && hasRooms(record.property_type.id, country_code) ?
										// se muestra el valor tal cual llega (incluso negativo) para que QA detecte datos inválidos
										`${record.rooms == null || record.rooms === "" ? 0 : record.rooms} Amb`
										: bedrooms >= 0 ?
											bedrooms === 0 && country_code !== "CO"
												? firstLetterToUppercase(translations.mono)
												: `${bedrooms} ${firstLetterToUppercase(translations.hab)}`
											: "-"
								}
							</>
						);
					}}
				/>
				<Table.Column
					title={<span className="small-text">Baños</span>}
					dataIndex="bathrooms"
					key="bathrooms"
					render={(bathrooms, record: any) => (
						<>
							{Number(record.property_type?.id) === 3 && bathrooms === 0
								? "-"
								: `${bathrooms} Baño${bathrooms != 1 ? "s" : ""}`}
						</>
					)}
				/>
				<Table.Column
					title={<span className="small-text">Precio</span>}
					dataIndex="price"
					key="price"
					className="nowrap"
					render={price => makePriceText(price)}
				/>
				{country_code !== "CO" && (
					<Table.Column
						title={<span className="small-text">{"Precio" + " x m²"}</span>}
						dataIndex="price"
						key="pricePerm2"
						className="nowrap"
						render={(price, row: any) => (
							<>
								{price && row.m2 &&
									makePriceText({ ...price, amount: price.amount / row.m2 })
								}
							</>
						)
						}
					/>
				)}
				<Table.Column
					title=""
					key={"action_col"}
					render={row => {
						if (asked.some(elem => elem == row.id))
							return <Typography.Text disabled>{"¡Preguntado!"}</Typography.Text>;
						else
							return (
								<button
									className="btnText"
									disabled={!isProjectActive}
									onClick={() => {
										if (!isLoggedIn) {
											openContactModal({
												id: row.id,
												owner: null,
												isProject: false,
												projectId: null,
												defaultMessage: "",
												source: "propertyDetail",
												isExpress: true,
												expressCallback: (e) => handleAskDisponibility(e, row.id),
												ctaToShow: {
													contact: true,
													phone: false,
													whatsapp: false
												}
											})
										} else {
											askFastDisponibility(row.id);
										}
									}}
								>
									{"Averiguar Disponibilidad"}
								</button>
							);
					}}
				/>
			</Table>
		</>
	);
};

